import React from 'react';
import { SystemText } from '@salesperformanceint/e4shared';
import { useSelector } from 'react-redux';
import { ResponsiveRadar } from '@nivo/radar';

const RadarChart = ({ data, item, id }) => {
    const [controlHeight, setControlHeight] = React.useState(0);

    const user = useSelector(state => state.user.user);
    const ratings = user.companySettings?.display?.ratingRange || 5;

    const textPrefix = 'Dashboard/Widgets/RadarCompetencies/';

    let keys = [];

    data = data.map(d => {
        let x = { ...d };
        d.data.forEach(s => {
            const prop = s.name;
            const key = SystemText(`${textPrefix}${prop}`);
            if (!keys.some(k => k === key)) keys = keys.concat([key]);
            x[key] = s.value;
        });

        return x;
    });

    React.useEffect(() => {
        const controlHeightGenerator = () => {
            const extrasHeight = 40;
            const me = document.querySelector(`#${id}`);
            let result = me ? (me.offsetHeight - extrasHeight).toFixed() : 400;
            return result;
        };

        const ps = controlHeightGenerator();

        setControlHeight(ps);
    }, [id, item.h, data]);

    return (
        <div style={{ height: `${controlHeight}px` }}>
            <ResponsiveRadar
                data={data}
                keys={keys}
                indexBy="name"
                minValue={0}
                maxValue={ratings}
                valueFormat=">-.2f"
                margin={{ top: 50, right: 80, bottom: 50, left: 80 }}
                borderColor={{ from: 'color' }}
                gridLabelOffset={36}
                dotSize={10}
                dotColor={{ theme: 'background' }}
                dotBorderWidth={2}
                colors={{ scheme: 'nivo' }}
                blendMode="multiply"
                motionConfig="wobbly"
                legends={[
                    {
                        anchor: 'top-left',
                        direction: 'column',
                        translateX: -50,
                        translateY: -40,
                        itemWidth: 80,
                        itemHeight: 20,
                        itemTextColor: '#999',
                        symbolSize: 12,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000',
                                },
                            },
                        ],
                    },
                ]}
            />
        </div>
    );
};

export default RadarChart;
